import React from "react";
import { useCart } from "../context/CartContext";
import { Link } from "react-router-dom";

const Cart = () => {
  const { cartItems, removeFromCart, changeQuantity, getTotal } = useCart();

  if (cartItems.length === 0)
    return (
      <div className="text-center py-20">
        <h2 className="text-2xl font-semibold">Your cart is empty ☕</h2>
        <Link to="/menu" className="text-blue-500 mt-4 block">
          Go to Menu
        </Link>
      </div>
    );

  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-3xl font-semibold mb-6">🛒 Your Cart</h2>
      {cartItems.map((item, index) => (
        <div
          key={index}
          className="flex items-center justify-between border-b py-4"
        >
          <div>
            <h3 className="text-lg font-medium">{item.name}</h3>
            <p className="text-sm text-gray-500">₹{item.price} each</p>
            <div className="flex items-center mt-2 space-x-2">
              <button
                className="px-2 py-1 bg-gray-200 rounded"
                onClick={() => changeQuantity(item.name, -1)}
              >
                −
              </button>
              <span>{item.quantity}</span>
              <button
                className="px-2 py-1 bg-gray-200 rounded"
                onClick={() => changeQuantity(item.name, 1)}
              >
                +
              </button>
            </div>
          </div>
          <div className="text-right">
            <p className="font-semibold">₹{item.price * item.quantity}</p>
            <button
              className="text-red-500 text-sm mt-1"
              onClick={() => removeFromCart(item.name)}
            >
              Remove
            </button>
          </div>
        </div>
      ))}
      <div className="mt-6 text-right">
        <h4 className="text-xl font-bold py-5">
          Total: ₹{getTotal().toFixed(2)}
        </h4>
        <Link to="/checkout" className="mt-4 px-4 py-2 bg-green-600 text-white rounded">
              Proceed to Checkout
            </Link>
      </div>
    </div>
  );
};

export default Cart;
